/**
 * Web Vitals reporter — forwards Core Web Vitals to Google Analytics 4
 * if window.gtag is loaded, and to any custom handler passed in.
 *
 * Metrics captured (web-vitals v2): CLS, FID, FCP, LCP, TTFB.
 * Upgrade to web-vitals v3+ to add INP.
 */
const sendToGA = ({ name, delta, value, id }) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    event_category: 'Web Vitals',
    event_label: id,
    // CLS comes in as a unitless decimal; everything else is milliseconds.
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    metric_id: id,
    metric_value: value,
    metric_delta: delta,
    non_interaction: true,
  });
};

const reportWebVitals = (onPerfEntry) => {
  const handler = (metric) => {
    sendToGA(metric);
    if (onPerfEntry && onPerfEntry instanceof Function) onPerfEntry(metric);
  };

  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(handler);
    getFID(handler);
    getFCP(handler);
    getLCP(handler);
    getTTFB(handler);
  });
};

export default reportWebVitals;
